import React from "react";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogFooter } from "@/components/ui/dialog";
import { Button } from "@/components/ui/button";
import { Printer, X } from "lucide-react";
import { inr } from "@/lib/utils_pharma";

function Slip({ p, shop, preview }) {
  if (!p) return null;
  const cls = preview ? "invoice-preview" : "print-area print-only";
  const style = preview
    ? { width: "72mm", padding: "2mm", fontFamily: "'IBM Plex Mono', 'Courier New', monospace",
        fontSize: 10, background: "#fff", color: "#000", border: "1px dashed #ccc", margin: "0 auto" }
    : undefined;
  return (
    <div className={cls} style={style} data-testid="purchase-print">
      <div style={{ textAlign: "center", marginBottom: 4 }}>
        <div style={{ fontWeight: 700, fontSize: 12 }}>{shop?.name || "Pharmacy"}</div>
        {shop?.address && <div style={{ fontSize: 9 }}>{shop.address}</div>}
        {shop?.phone && <div style={{ fontSize: 9 }}>Ph: {shop.phone}</div>}
        <div style={{ fontWeight: 700, fontSize: 11, marginTop: 4, borderTop: "1px dashed #000", paddingTop: 2 }}>
          PURCHASE INVOICE
        </div>
      </div>
      <div style={{ borderTop: "1px dashed #000", borderBottom: "1px dashed #000", padding: "2px 0", fontSize: 9 }}>
        <div style={{ display: "flex", justifyContent: "space-between" }}>
          <span>Inv: {p.invoice_no}</span>
          <span>{p.invoice_date}</span>
        </div>
        <div>Supplier: {p.supplier_name || "-"}</div>
      </div>
      <div style={{ marginTop: 4, fontSize: 9 }}>
        {p.items?.map((it, i) => {
          const line = it.purchase_price * it.quantity;
          return (
            <div key={i} style={{ paddingTop: 2 }}>
              <div>{it.medicine_name}</div>
              <div style={{ fontSize: 8 }}>B:{it.batch_no || "-"} Exp:{it.expiry_date || "-"} GST {it.gst_percent}%</div>
              <div style={{ display: "flex", justifyContent: "space-between" }}>
                <span>{it.quantity} × {inr(it.purchase_price)}</span>
                <span>{inr(line)}</span>
              </div>
            </div>
          );
        })}
      </div>
      <div style={{ borderTop: "1px dashed #000", marginTop: 4, paddingTop: 3, fontSize: 9 }}>
        <Row l="Subtotal" v={inr(p.subtotal)} />
        <Row l="Tax" v={inr(p.tax_amount)} />
        <div style={{ borderTop: "1px dashed #000", marginTop: 2, paddingTop: 2, fontWeight: 700, fontSize: 11 }}>
          <Row l="TOTAL" v={inr(p.total)} />
        </div>
      </div>
      <div style={{ textAlign: "center", marginTop: 6, borderTop: "1px dashed #000", paddingTop: 3, fontSize: 9 }}>
        Stock updated on receipt
      </div>
    </div>
  );
}

function Row({ l, v }) {
  return <div style={{ display: "flex", justifyContent: "space-between" }}><span>{l}</span><span>{v}</span></div>;
}

export default function PurchasePreviewDialog({ open, onOpenChange, purchase, shop }) {
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="max-w-md" data-testid="purchase-preview-dialog">
        <DialogHeader>
          <DialogTitle className="flex items-center justify-between">
            <span>Purchase Slip · 72mm</span>
            {purchase?.invoice_no && <span className="font-mono text-xs text-muted-foreground">{purchase.invoice_no}</span>}
          </DialogTitle>
        </DialogHeader>
        <div className="bg-muted rounded-md py-4 max-h-[65vh] overflow-auto">
          <Slip p={purchase} shop={shop} preview />
        </div>
        <div className="text-xs text-muted-foreground text-center">Ready for your 3-inch (72mm) thermal printer.</div>
        <DialogFooter className="gap-2">
          <Button variant="outline" onClick={() => onOpenChange(false)}><X size={14} className="mr-1" /> Close</Button>
          <Button onClick={() => window.print()} data-testid="purchase-print-btn"><Printer size={14} className="mr-1" /> Print</Button>
        </DialogFooter>
        {purchase && <Slip p={purchase} shop={shop} />}
      </DialogContent>
    </Dialog>
  );
}
